import {Component, Input} from '@angular/core';

/**
 * One cell in the ecommerce dashboard's balance bar. Drives label, value, optional tooltip, optional description,
 * and two visual states:
 *
 *   - `empty`       — value is present but represents "nothing pending" (greyed-out to soften the R 0.00 so a quiet
 *                     day doesn't look like the feature is broken).
 *   - `unavailable` — backend call failed; replace the numeric value with the placeholder text.
 *
 * Kept as a dumb input-only component; the parent owns all the data + tooltip-copy logic.
 */
@Component({
    selector: 'app-balance-tile',
    templateUrl: './balance-tile.component.html',
    styleUrls: ['./balance-tile.component.scss'],
    standalone: false
})
export class BalanceTileComponent
{
    @Input() label!: string;
    @Input() tooltipText?: string;
    @Input() value: string | null = null;
    @Input() description?: string;
    @Input() empty = false;
    @Input() unavailable = false;
    @Input() unavailableText = 'Data unavailable';
}
